import React from "react";
import HeaderBanner from "../Components/HeaderBanner";
import Footer from "../Components/Footer";
import Bg1 from "../Images/bg1.png";
import UprightArrow from "../Images/up-right.png";
import StaffList from "../Components/StaffList";

const StaffDetails = () => {
	return (
		<div>
			<HeaderBanner
				bannerImage={Bg1}
				logoText={"Modern Public School"}
				subTitle={"Staff List"}
				buttonLogo={UprightArrow}
			/>
			<StaffList />
			<Footer />
		</div>
	);
};
export default StaffDetails;
